import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface RequestsBusinessUnitPayload extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_REQUESTS_BUSINESS_UNIT;
    id: string;
    attributes: {
      data: Array<{
        business_unit_id: string | null;
        business_unit_title: string;
        request_status: string;
        request_count: number;
        business_unit_total_count: number;
      }>;
    };
  };
}

export const parseRequestsBusinessUnitPayload = (
  payload: BaseInsightPayload
): RequestsBusinessUnitPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_REQUESTS_BUSINESS_UNIT,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      business_unit_id: string | null;
      business_unit_title: string;
      request_status: string;
      request_count: number;
      business_unit_total_count: number;
    }>;
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_REQUESTS_BUSINESS_UNIT,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
